import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import EmptyWidget from '../base/EmptyWidget'

const eventName = 'licenseReady'

export const LicenseTypes = {
    src: null,
    noScript: [
        "Curacao eGaming",
        "Gaming Curacao"
    ],
    Curacao: {
        'Curacao eGamings': { name: 'Curacao eGamings' },
        'Gaming Curacao': { name: 'Gaming Curacao' },
        "Antillephone": {
            name: "Antillephone",
            prefix: "apg",
            scriptPostfix: "snippet.antillephone.com/apg-seal.js"
        }
    },

    eventHandler: (e) => {
        if (document.querySelectorAll('[src="' + LicenseTypes.src + '"]').length) {
            document.querySelectorAll('[src="' + LicenseTypes.src + '"]')[0].remove()
        }
        var script = document.createElement('script')
        script.setAttribute('src', LicenseTypes.src)
        document.head.appendChild(script)
    },

    scriptInsertMethod: function (src) {
        LicenseTypes.src = src;
        document.removeEventListener(eventName, LicenseTypes.eventHandler);
        document.addEventListener(eventName, LicenseTypes.eventHandler, false)
    }
}
class License extends React.Component {
    componentDidMount() {
        Object.keys(this.props.licenses).length && document.dispatchEvent(new Event(eventName));
    }
    componentDidUpdate(prevProps) {
        if (Object.keys(this.props.licenses).length !== Object.keys(prevProps.licenses).length) {
            document.dispatchEvent(new Event(eventName));
        }
    }
    getLicenseHtml = (license, key) => {
        const sealId = license.sealId;
        let html = ''
        switch (license.body) {
            case 'Curacao eGaming':
                html = <a key={key} href={`https://verification.curacao-egaming.com/validateview.aspx?domain=${sealId ? sealId : window.location.hostname}`} target="_blank">
                    <img src={`https://verification.curacao-egaming.com/validate.ashx?domain=${sealId ? sealId : window.location.hostname}`} alt="" width="100" />
                </a>
                break;
            case 'Gaming Curacao':
                html = <iframe key={key} src={`https://licensing.gaming-curacao.com/validator/?lh=${sealId}&template=tseal`} width={150} height={50} style={{ border: "none" }}></iframe>
                break;
            case 'Antillephone':
                const prefix = LicenseTypes[license.name][license.body].prefix;
                const dataProps = {}
                dataProps['id'] = `${prefix}-${sealId}`;
                dataProps[`data-${prefix}-seal-id`] = sealId
                html = <div  {...dataProps} key={key}>
                </div>
                break;
            default:
                html = '';
                break;
        }
        return html;
    }
    render() {
        const { licenses = {} } = this.props;
        const licenseMarkup = Object.keys(licenses).length ? Object.keys(licenses).map((key) => {
            return this.getLicenseHtml(licenses[key], key)
        }) : null

        return (
            <>
                {Object.keys(licenses).length ? (
                    <div style={{ backgroundColor: 'transparent' }} className='footer--license tb--flex tb--justify-center'>
                        {licenseMarkup}
                    </div>
                ) : <EmptyWidget {...this.props} isNotManagable={true}/>}
            </>
        )
    }
}
const mapDispatchToProps = (dispatch, props) => {
    return ({
        dispatch
    });
}

const mapStateToProps = state => {
    return {
        licenses: state.settings.licenses
    }
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(License));

